"use strict";
/*
 * Created on 03 05 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutEndReasonConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutEndReasonConverter, _DataObjectConverter_);

  function SelloutEndReasonConverter() {
    _classCallCheck(this, SelloutEndReasonConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutEndReasonConverter).apply(this, arguments));
  }

  return SelloutEndReasonConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutEndReasonConverter = SelloutEndReasonConverter;